<template>
  <ECard
    v-if="hasItems"
    class="product-ads-list"
    as="section"
  >
    <div class="product-ads-list__header">
      <EHeading
        as="h2"
        class="product-ads-list__title"
        data-test-id="product-ads-list-title"
      >
        <ELink
          :href="shoppingUrl"
          color="result"
          data-test-id="product-ads-list-title-link"
        >
          {{ title }}
        </ELink>
      </EHeading>
      <EAdLabel
        class="product-ads-list__ad-label"
        data-test-id="product-ads-list-ad-label"
        tooltip-side="left-center"
        @report-clicked="onAdReportClick"
      >
        {{ $t('common.search.results.productads.label') }}
      </EAdLabel>
    </div>
    <EAdQualityFeedbackLink
      ref="ad-report"
      :widget-type="'product_ad_list_result'"
      :origin="shoppingUrl"
      class="product-ads-list__report-link"
    />
    <ul class="product-ads-list__list" :aria-label="title">
      <li
        v-for="(item, index) in items"
        :key="index"
        class="product-ads-list__item"
        data-test-id="product-ads-list-item"
      >
        <EProductAdsListItem
          :rank="index"
          :title="item.title"
          :url="item.url"
          :source="item.source"
          :thumbnail-url="item.thumbnailUrl"
          :price="item.price"
          :shipping-info="item.shippingInfo"
          :price-per-unit="item.pricePerUnit"
          :energy-rating="item.energyRating"
          :badge="item.badge"
          :ping-suffix="item.pingSuffix"
        />
      </li>
      <li class="product-ads-list__item product-ads-list__item--last">
        <EButton as="a" :href="shoppingUrl" variant="outline" size="s" icon="shopping">
          {{ $t('common.search.results.productads.more') }}
        </EButton>
      </li>
    </ul>
  </ECard>
</template>

<script>
import { getUrlQuery } from '~~/common/js/universal/search';
import EAdLabel from '~~/common/vue/components/ad-label';
import ECard from '~~/common/vue/components/card';
import EHeading from '~~/common/vue/components/heading';
import ELink from '~~/common/vue/components/link';
import EButton from '~~/common/vue/components/button';
import EProductAdsListItem from './item';
import EAdQualityFeedbackLink from '~~/search/common/vue/components/ad-quality-feedback-link';

export default {
  name: 'EProductAdsList',
  components: {
    EAdLabel,
    ECard,
    EHeading,
    ELink,
    EButton,
    EProductAdsListItem,
    EAdQualityFeedbackLink,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  computed: {
    title() {
      return `${this.$t('web.productads.title')} ${this.$route.query.q?.toString()}`;
    },
    hasItems() {
      return this.items?.length;
    },
    shoppingUrl() {
      const query = getUrlQuery(this.$route.query, this.$store.state.user);
      return this.$router.resolve({ path: '/shopping', query }).href;
    },
  },
  methods: {
    onAdReportClick() {
      this.$refs['ad-report']?.$el.click();
    },
  },
};
</script>

<style lang="scss" scoped>
.product-ads-list {
  overflow: visible;
}

.product-ads-list__header {
  @include divider('bottom');

  display: flex;
  padding: $space-m $space-m $space-1s;
}

.product-ads-list__title {
  @extend %ellipsis;

  color: var(--color-text-secondary);
  font-size: $font-m;
  font-weight: $font-weight-m;
}

.product-ads-list__ad-label {
  margin-left: auto;
}

.product-ads-list__list {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.product-ads-list__item {
  padding: $space-1s $space-m;

  & + & {
    @include divider('top');
  }
}

.product-ads-list__item--last {
  padding-top: $space-1l;
  padding-bottom: $space-2l;
  background: url(~~/search/common/vue/assets/img/product-ads-shopping.svg?asPath)
    no-repeat
    right
    $space-1s
    center;
}
</style>
